export default __webpack_public_path__ + "static/media/cycloneofsteel1.812985ee.png";